import * as React from 'react';
import { useState, useEffect, useRef } from 'react';
import * as _ from 'lodash';
import { createSidebar } from '../../redux/actions/general/sidebar';
import {
  enableProjectsDropdown,
  enableStagesDropdown,
  listActiveModules,
} from '../../redux/actions/general/active_modules';
import {
  __,
  getActiveStage,
  getURLParam,
  redirect,
  setTableParams,
  setURLParam,
  sortValuesByArray,
} from '../../core/utils';
import styles from '../../styles/views/plans/PlanRevisionPreview.scss';
import ArrowLeftMiddleIcon from '../../assets/images/arrow-left-middle-15x15.svg';
import ArrowRightSmallIcon from '../../assets/images/arrow-right-small-15x15.svg';
import queryString from 'query-string';
import { connect } from 'react-redux';
import classNames from 'classnames';
import InfoPositiveIcon from '../../assets/images/info-positive-16x16.svg';
import CompareIcon from '../../assets/images/compare-15x15.svg';
import Tooltip from '../../components/Tooltip';
import Localization from '../../helpers/Localization';
import { withRouter } from 'react-router';
import { subscribe } from 'react-contextual';
import Viewer from '../../components/CanvasEditor/components/Viewer';
import Toolbar from '../../components/CanvasEditor/components/Toolbar/Toolbar';

import {
  findTaskObjectOnCanvas,
  resetObjectStyle,
  selectObjectStyle,
} from '../../components/CanvasEditor/helpers/fabricHelpers';

import { readTask } from '../../redux/actions/table/all_tasks';
import TasksFlyout from '../../flyouts/tasks/TasksFlyout';
import { getStatusColor } from '../../components/CanvasEditor/components/Task/taskStatusColors';
import TitleBar from '../../containers/TitleBar';
import ArrowDoubleLeftMiddleIcon from '../../assets/images/arrow-double-left-middle-15x15.svg';
import ArrowRightMiddleIcon from '../../assets/images/arrow-right-middle-15x15.svg';
import ArrowDoubleRightMiddleIcon from '../../assets/images/arrow-double-right-middle-15x15.svg';
import ReactDOM from 'react-dom';
import CurrentSetPlansFlyout from '../../flyouts/current_set_plans/CurrentSetPlansFlyout';
import {
  filterPlanRevisionAnnotations,
  listComparablePlanRevisions,
  listComparablePlanRevisionsByDiscipline,
  listPinnedPlanRevisionSpecifications,
  listPlanRevisionPlans,
  listPlanRevisionTasks,
  listPossiblePlanRevisionByDiscipline,
  readCurrentSetPlan,
  readPlanRevision,
  readPlanRevisionAnotation,
  updatePlanRevisionAnotation,
} from '../../redux/actions/table/current_set_plans';
import Filter from '../../components/CanvasEditor/components/Filter/Filter';
import FilterIcon from '../../assets/images/filter-15x15.svg';
import { getPreferences } from '../../redux/actions/profile';
import { isSafari } from 'react-device-detect';
import ComparePlans from './components/ComparePlans/ComparePlans';
import { readCurrentSetSpecification } from '../../redux/actions/table/current_set_specifications';
import CurrentSetSpecificationsFlyout from '../../flyouts/current_set_specifications/CurrentSetSpecificationsFlyout';
import ArrowDownSmallIcon from '../../assets/images/arrow-down-small-15x15.svg';
import Dropdown from '../../components/Dropdown';
import { hideDropdown } from '../../redux/actions/general/dropdown';
import SearchableDropdown from '../../components/SearchableDropdown';
import SearchInline from '../../components/CanvasEditor/components/Search/SearchInline';
import {
  parsePlanPdfToJson,
  searchPdfTextPositions,
} from '../../redux/actions/table/working_set_plans';
import { setNotification } from '../../redux/actions/general/notification';
import CanvasEditor from '../../components/CanvasEditor/CanvasEditor';
import DownloadIcon from '../../assets/images/download-15x15.svg';

const PlanRevisionPreview = ({
  table: {
    annotations,
    pinned_tasks,
    data,
    clicked_row,
    filters,
    showFilters,
    flyout,
  },
  canvas_editor: { viewer, fabricOverlay },
  match,
  location,
  task_table,
  actions,
  localization,
  history,
  current_set_specifications,
}) => {
  const [planRevisionData, setPlanRevisionData] = useState(null);
  const [taskPreview, setTaskPreview] = useState(null);
  const [plansByDiscipline, setPlansByDiscipline] = useState([]);

  const [isPreparingSearch, setIsPreparingSearch] = useState(false);

  const prevTaskStatusRef = useRef();
  const prevClickedRowRef = useRef();

  const plan_revision_id = match.params.plan_revision;

  useEffect(() => {
    readPlanRevision(plan_revision_id).then(({ response }) => {
      const plan_revision_data = response.data;

      const params = queryString.parse(location.search);

      _.each(params, (value, key) => {
        //TODO - try to merge this with the upper keys using pickBy()
        if (_.startsWith(key, 'filter.')) {
          const params = {};
          params[key] = value;

          setTableParams('current_set_plans', params);
        }
      });

      listPinnedPlanRevisionSpecifications(plan_revision_id);

      listPlanRevisionPlans(plan_revision_id);

      listPlanRevisionTasks(plan_revision_id).then(({ response }) => {
        readPlanRevisionAnotation(plan_revision_id).then(({ response }) => {
          setPlanRevisionData(plan_revision_data);
        });
      });

      listActiveModules();

      readCurrentSetPlan(response.data.plan.id).then(({ response }) => {});

      listPossiblePlanRevisionByDiscipline(plan_revision_id).then(
        ({ response }) => {
          setPlansByDiscipline(response.data);
        }
      );

      getPreferences(`current_set_plans.plan_revision_preview`).then(
        ({ response: { data } }) => {
          const user_preference_params = _.transform(
            data,
            (params, value, key) => {
              if (_.startsWith(key, 'filter_')) {
                params[key.replace('filter_', 'filter.')] = _.toString(value);
              } else {
                params[key] = value;
              }
            },
            {}
          );

          setTableParams(
            'current_set_plans',
            _.pick(user_preference_params, [
              'disabled_columns',
              'pinned_columns',
              'view',
            ])
          );
        }
      );

      enableProjectsDropdown(({ stage_id }) =>
        redirect('/stages/' + stage_id + '/plans/current')
      );
      enableStagesDropdown(({ stage_id }) =>
        redirect('/stages/' + stage_id + '/plans/current')
      );

      createSidebar({
        title: __('submenu.title.plans'),
        items: [
          {
            title: __('submenu.title.current-set'),
            link: () => '/stages/' + getActiveStage() + '/plans/current',
            active: true,
          },
          {
            title: __('submenu.title.working-set'),
            link: () => '/stages/' + getActiveStage() + '/plans/working',
          },
          {
            title: __('submenu.title.uploads'),
            link: () => '/stages/' + getActiveStage() + '/plans/uploads',
          },
          {
            title: __('submenu.title.deliveries'),
            link: () => '/stages/' + getActiveStage() + '/deliveries',
          },
          {
            title: __('submenu.title.approvals'),
            link: () => '/stages/' + getActiveStage() + '/approvals',
          },
        ],
      });
    });

    if (getURLParam('specification_id'))
      readCurrentSetSpecification(getURLParam('specification_id')).then(
        ({ response }) => {
          setTableParams('current_set_specifications', {
            clicked_row: response.data.id,
            flyout: response.data,
          });
        }
      );

    if (getURLParam('task_id'))
      readTask(getURLParam('task_id')).then(({ response }) => {
        setTableParams('all_tasks', {
          clicked_row: response.data.id,
        });
        setTaskPreview(response.data);
      });

    if (getURLParam('id'))
      actions.setTableParams({ clicked_row: getURLParam('id') });
  }, []);

  useEffect(() => {
    const clickedRow = task_table?.clicked_row;
    const prevClickedRow = prevClickedRowRef.current;

    if (clickedRow) {
      readTask(clickedRow).then(({ response }) => {
        prevTaskStatusRef.current = response.data.status;

        setTaskPreview(response.data);
      });
    }

    if (!clickedRow && clickedRow !== prevClickedRow) {
      setURLParam('task_id', '');
    }

    prevClickedRowRef.current = clickedRow;
  }, [task_table?.clicked_row]);

  useEffect(() => {
    const currentStatus = task_table?.flyout?.status;
    const prevStatus = prevTaskStatusRef.current;

    if (prevStatus !== undefined && currentStatus !== prevStatus) {
      if (task_table?.clicked_row && currentStatus) {
        const canvas = fabricOverlay.fabricCanvas();

        const taskObj = findTaskObjectOnCanvas(canvas, task_table?.clicked_row);

        if (taskObj) {
          const color = getStatusColor(currentStatus);
          taskObj.set({
            stroke: color,
            fill: color,
          });
          canvas.requestRenderAll();
        }
      }

      prevTaskStatusRef.current = currentStatus;
    }
  }, [task_table?.flyout?.status]);

  useEffect(() => {
    const clickedRow = current_set_specifications?.clicked_row;
    const prevClickedRow = prevClickedRowRef.current;

    if (clickedRow) {
      readCurrentSetSpecification(clickedRow).then(({ response }) => {
        setTableParams('current_set_specifications', {
          flyout: response.data,
        });
      });
    }

    if (!clickedRow && clickedRow !== prevClickedRow) {
      setURLParam('specification_id', '');
    }

    prevClickedRowRef.current = clickedRow;
  }, [current_set_specifications?.clicked_row]);

  useEffect(() => {
    const prevClickedRow = prevClickedRowRef.current;

    if (!clicked_row && clicked_row !== prevClickedRow) {
      setURLParam('id', '');
    }

    prevClickedRowRef.current = clicked_row;
  }, [clicked_row]);

  const handleSubmit = (fabricOverlay, refreshData = false) => {
    const canvas = fabricOverlay.fabricCanvas();
    const activeObject = canvas.getActiveObject();

    if (activeObject?.type === 'activeSelection') {
      activeObject.getObjects().forEach((child) => {
        child.setCoords();
      });
      canvas.discardActiveObject();
    }

    activeObject && resetObjectStyle(activeObject);

    const allObjects = canvas
      .getObjects()
      .filter(
        (obj) => !['controlpoint', 'arrow-head'].includes(obj.objectType)
      );

    const serializedObjects = {
      objects: allObjects.map((obj) =>
        obj.toObject([
          'objectType',
          'originalLeft',
          'originalTop',
          'taskID',
          'planID',
          'specificationCodeID',
          'userID',
          'lockMovementX',
          'lockMovementY',
          'userFullName',
          'objectCaching',
        ])
      ),
    };

    activeObject && selectObjectStyle(activeObject);
    updatePlanRevisionAnotation(
      plan_revision_id,
      JSON.stringify(serializedObjects)
    ).then(() => {
      if (refreshData) {
        readPlanRevision(plan_revision_id);

        readPlanRevisionAnotation(plan_revision_id).then(({ response }) => {
          //setPlanRevisionData(plan_revision_data);
        });
      }
    });
  };

  const _goBack = () => {
    // window.previousLocation
    //   ? window.history.back()
    //   : redirect('/stages/' + getActiveStage() + '/plans/current');

    redirect('/stages/' + getActiveStage() + '/plans/current');
  };

  const _setURLParams = (params) => {
    const search = queryString.stringify({
      ...queryString.parse(location.search),
      ...params,
    });
    redirect({ search }, true);
  };

  const filtersSort = (filter, value, label) => {
    switch (filter) {
      case 'status':
        return sortValuesByArray(
          [
            'not-started',
            'started',
            'reopened',
            'finished',
            'closed',
            'canceled',
          ],
          value
        );
    }
  };

  const _toggleFilterFlyout = () => {
    setTableParams('current_set_plans', {
      showFilters: !showFilters,
    });

    setTableParams('all_tasks', {
      clicked_row: undefined,
    });
  };

  const _toggleCompareTool = () => {
    const compare = _.get(
      queryString.parse(location.search),
      'compare',
      undefined
    );

    redirect(
      {
        search: queryString.stringify({
          ...queryString.parse(location.search),
          compare: compare ? undefined : '1',
        }),
      },
      true
    );
  };

  const handleNeighborClick = (plan_revision_id) => {
    redirect('/plans/revisions/' + plan_revision_id);
  };

  let first_plan_id, last_plan_id, prev_plan_id, next_plan_id;

  if (!_.isEmpty(data) && planRevisionData) {
    first_plan_id = _.first(data).last_revision.id;
    last_plan_id = _.last(data).last_revision.id;

    prev_plan_id =
      _.get(data, [
        _.findIndex(data, ['id', planRevisionData.plan.id]) - 1,
        'last_revision',
        'id',
      ]) || first_plan_id;
    next_plan_id =
      _.get(data, [
        _.findIndex(data, ['id', planRevisionData.plan.id]) + 1,
        'last_revision',
        'id',
      ]) || last_plan_id;
  }

  const handleParsePdf = () => {
    setIsPreparingSearch(true);

    return parsePlanPdfToJson(flyout.plan_version_id)
      .then(() => {
        return readCurrentSetPlan(flyout.id);
      })
      .then(() => {
        setNotification(
          __('plans.current-set.notification.pdf-to-json.parsing-started')
        );
      })
      .finally(() => {
        setIsPreparingSearch(false);
      });
  };

  const RenderLeftTitleComponent = () => {
    const disciplineName =
      planRevisionData.plan.discipline.id == null
        ? planRevisionData.plan.discipline.description + '*'
        : _.get(localization.disciplines, [
            planRevisionData.plan.discipline.id,
            'name',
          ]);

    const planName = _.filter(
      [planRevisionData.plan.code, planRevisionData.plan.title],
      _.identity
    ).join(': ');

    return (
      <div className={styles.left}>
        <div className={styles.back} onClick={_goBack}>
          <Tooltip text={__('plans.tooltip.icon.back-to-list')}>
            <ArrowLeftMiddleIcon />
          </Tooltip>
        </div>

        <div className={styles.separator} />

        <TitleBar
          title={__('submenu.title.current-set')}
          dropdownHeader={__('submenu.title.plans')}
          loading={false}
        />

        <ArrowRightSmallIcon />

        {disciplineName}

        <ArrowRightSmallIcon />

        <SearchableDropdown
          leftStyled
          name={planName}
          dropdownWrapperClassName={styles.dropdownMenuWrapper}
          header={
            <div className={styles.dropdownMenuHeader}>
              {__('titlemenu.header.plan')}
            </div>
          }
          options={plansByDiscipline}
          showSearchInput
          onSelect={(item) => {
            redirect('/plans/revisions/' + item.value, true);

            hideDropdown();
          }}
        >
          <div className={styles.label}>
            {planName}

            <ArrowDownSmallIcon />
          </div>
        </SearchableDropdown>
      </div>
    );
  };

  const can_compare =
    planRevisionData &&
    (planRevisionData?.revisions > 1 || flyout?.has_identifiers);

  const plan_has_tiles = !_.isEmpty(planRevisionData?.plan?.tiles);

  const compare_has_tiles =
    planRevisionData?.plan?.tiles_available !== false && plan_has_tiles;

  const compare =
    _.has(queryString.parse(location.search), 'compare') &&
    can_compare &&
    compare_has_tiles &&
    !isSafari;

  const url_parameters = queryString.parse(history.location.search);

  if (compare && url_parameters.compare === '1') {
    return (
      <ComparePlans
        name={'revisions'}
        action={() => listComparablePlanRevisions(plan_revision_id)}
        compareByDiscipline={() =>
          listComparablePlanRevisionsByDiscipline(plan_revision_id)
        }
        onInfoIconClick={() => {
          actions.setTableParams({
            clicked_row: flyout.id,
          });

          setURLParam('id', flyout.id);
        }}
        planWidth={planRevisionData.plan.width}
        planHeight={planRevisionData.plan.height}
        leftTitleComponent={<RenderLeftTitleComponent />}
      />
    );
  }

  const neighbor_directions = [
    { key: 'left', tooltip: __('content.tooltip.table.left-child-plan') },
    { key: 'up', tooltip: __('content.tooltip.table.up-child-plan') },
    { key: 'right', tooltip: __('content.tooltip.table.right-child-plan') },
    { key: 'down', tooltip: __('content.tooltip.table.down-child-plan') },
  ];

  return (
    <div className={styles.wrapper}>
      <div className={styles.toolbar}>
        {planRevisionData && (
          <div className={styles.title}>
            <RenderLeftTitleComponent />

            <div className={styles.right}>
              <SearchInline
                onSearch={(query) => {
                  return searchPdfTextPositions(flyout.plan_version_id, query);
                }}
                disabled={!flyout?.is_parsed_pdf_to_json}
                onPrepareSearch={handleParsePdf}
                loading={isPreparingSearch}
              />

              <div className={styles.separator} />

              <Tooltip
                text={__('plans.tooltip.icon.current-set.download-revision')}
              >
                <DownloadIcon
                  onClick={() => {
                    actions.setTableParams({
                      export_plan_annotations_wizard: true,
                    });
                  }}
                />
              </Tooltip>

              <div className={styles.separator} />

              {can_compare && (isSafari || !compare_has_tiles) && (
                <Tooltip
                  text={
                    isSafari
                      ? 'Compare tool is not available in Safari browser'
                      : __('plans.tooltip.icon.compare-disabled-no-tiles')
                  }
                >
                  <CompareIcon
                    className={classNames(
                      compare && styles.active,
                      styles.disabled
                    )}
                  />
                </Tooltip>
              )}
              {can_compare && compare_has_tiles && !isSafari && (
                <Tooltip text={__('plans.tooltip.icon.plan-revision-compare')}>
                  <CompareIcon
                    className={classNames(compare && styles.active)}
                    onClick={_toggleCompareTool}
                  />
                </Tooltip>
              )}

              {can_compare && <div className={styles.separator} />}

              {!_.isEmpty(filters) && (
                <>
                  <Tooltip text={__('plans.tooltip.icon.filters')}>
                    <FilterIcon
                      className={styles.filter}
                      onClick={_toggleFilterFlyout}
                    />
                  </Tooltip>
                </>
              )}

              <div className={styles.separator} />

              <Tooltip text={__('plans.tooltip.icon.plan-properties')}>
                <InfoPositiveIcon
                  className=''
                  onClick={() => {
                    actions.setTableParams({
                      clicked_row: flyout.id,
                    });

                    setURLParam('id', flyout.id);
                  }}
                />
              </Tooltip>
            </div>
          </div>
        )}
      </div>

      {/* Filter */}

      <Filter
        name={'current_set_plans'}
        setURLParams={(params) => _setURLParams(params)}
        filterData={filterPlanRevisionAnnotations}
        filtersSort={filtersSort}
        source={'plan_revision_preview'}
      />

      {/* Table */}

      {planRevisionData && (
        <CanvasEditor
          annotations={annotations}
          onSubmit={handleSubmit}
          pinnedTasks={pinned_tasks}
          source={planRevisionData?.plan}
          sourceType='plan'
        >
          <div className={styles.neighbors} id='neighbors'>
            {neighbor_directions.map(({ key, tooltip }) => (
              <Tooltip key={key} text={tooltip}>
                <ArrowDoubleLeftMiddleIcon
                  className={classNames(
                    styles[key],
                    flyout?.neighbors?.[key] && styles.active
                  )}
                  onClick={() => handleNeighborClick(flyout?.neighbors?.[key])}
                />
              </Tooltip>
            ))}
          </div>
        </CanvasEditor>
      )}

      {/* Footer */}

      {!_.isEmpty(data) && planRevisionData && (
        <div className={styles.footer}>
          <div className={styles.pagination}>
            <Tooltip text={__('content.tooltip.table.first-page')}>
              <ArrowDoubleLeftMiddleIcon
                onClick={() =>
                  redirect('/plans/revisions/' + first_plan_id, true)
                }
              />
            </Tooltip>
            <Tooltip text={__('content.tooltip.table.prev-page')}>
              <ArrowLeftMiddleIcon
                onClick={() =>
                  redirect('/plans/revisions/' + prev_plan_id, true)
                }
              />
            </Tooltip>
            <span className={classNames(styles.page, styles.active)}>
              {planRevisionData.plan.code}
            </span>
            <Tooltip text={__('content.tooltip.table.next-page')}>
              <ArrowRightMiddleIcon
                onClick={() =>
                  redirect('/plans/revisions/' + next_plan_id, true)
                }
              />
            </Tooltip>
            <Tooltip text={__('content.tooltip.table.last-page')}>
              <ArrowDoubleRightMiddleIcon
                onClick={() =>
                  redirect('/plans/revisions/' + last_plan_id, true)
                }
              />
            </Tooltip>
          </div>
        </div>
      )}

      {/* Flyout */}

      <div
        className={classNames(
          styles.flyout,
          (clicked_row || task_table?.clicked_row) && styles.active
        )}
      >
        {clicked_row && flyout && (
          <CurrentSetPlansFlyout
            data={flyout}
            readAction={(id) => {
              return new Promise((resolve) => {
                readCurrentSetPlan(planRevisionData.plan.id).then(
                  ({ response }) => {
                    readPlanRevision(match.params.plan_revision).then(
                      ({ response }) => {
                        setPlanRevisionData(response.data);

                        resolve(response);
                      }
                    );

                    this.setState({ preview: response.data });
                  }
                );
              });
            }}
          />
        )}
      </div>

      {task_table?.clicked_row &&
        taskPreview &&
        viewer &&
        ReactDOM.createPortal(
          <div
            style={{ top: 0 }}
            className={classNames(
              styles.flyout,
              (clicked_row || task_table?.clicked_row) && styles.active
            )}
          >
            <TasksFlyout
              data={taskPreview}
              readAction={(task_id) => {
                return new Promise((resolve) => {
                  readTask(task_id).then(({ response }) => {
                    setTaskPreview(response.data);

                    resolve(response);
                  });
                });
              }}
            />
          </div>,
          viewer.container
        )}

      {current_set_specifications?.clicked_row &&
        current_set_specifications?.flyout &&
        viewer &&
        ReactDOM.createPortal(
          <div
            style={{ top: 0 }}
            className={classNames(styles.flyout, styles.active)}
          >
            <CurrentSetSpecificationsFlyout
              data={current_set_specifications.flyout}
              readAction={(specification_id) => {
                return new Promise((resolve) => {
                  readCurrentSetSpecification(specification_id).then(
                    ({ response }) => {
                      setTableParams('current_set_specifications', {
                        flyout: response.data,
                      });

                      resolve(response);
                    }
                  );
                });
              }}
            />
          </div>,
          viewer.container
        )}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    canvas_editor: state.canvas_editor,
    task_table: state.table['all_tasks'],
    table: state.table['current_set_plans'],
    current_set_specifications: state.table['current_set_specifications'],
  };
};

const mapDispatchToProps = (dispatch, props) => {
  return {
    actions: {
      setTableParams: (params) =>
        dispatch({
          type: 'table.current_set_plans/SET_TABLE_PARAMS',
          params,
        }),
    },
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(subscribe(Localization, 'localization')(PlanRevisionPreview))
);
